import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Immutable from 'immutable';
import * as actions from '../../actions';
import { fetchWithJson } from '../../utils/api';
import ProfileList from '../../components/ProfileList';
import LoadSpinner from '../../components/LoadSpinner/index';
import tiaraClickSender from '../../utils/tiaraClickSender';

export class ProfileRecommendPage extends Component {
  constructor(props) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
    this.fetchProfile = this.fetchProfile.bind(this);
    this.state = {
      profiles: Immutable.List(),
      currentPage: 1,
      hasNext: true,
      isFetching: false
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    this.fetchProfile();  
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    const container = ReactDOM.findDOMNode(this);
    if (window.pageYOffset + window.innerHeight >= container.offsetHeight + container.offsetTop) {
      this.fetchProfile();
    }
  }
  
  fetchProfile() {
    const { profiles, hasNext, isFetching, currentPage } = this.state;
    if (!hasNext || isFetching) {
      return;
    }
    
    this.setState({ isFetching: true });
    fetchWithJson(`/api/portal/profiles/recommends?page=${currentPage}`).then(result => {
      const items = result.items;
      if (items) {
        this.setState({
          profiles: profiles.concat(Immutable.fromJS(items)),
          isFetching: false,
          hasNext: result.hasNext,
          currentPage: currentPage + 1
        });
      } else {
        this.setState({
          hasNext: false,
          isFetching: false
        });
      }
    }).catch(e => {
      console.error(e.stack);
      this.setState({
        hasNext: false,
        isFetching: false
      });
    });
  }

  render() {
    const { device } = this.props;
    const { profiles, isFetching } = this.state;
    return (
      <div>
        <header id="kakaoHead">
          <h1 className="screen_out">카카오톡 채널</h1>
        </header>
        <hr className="hide" />
        <main id="kakaoContent">
          <article id="mArticle">
            <h2 className="screen_out">추천 채널</h2>
            <div data-tiara-layer="recommend_page">
              <ProfileList
                device={device}
                profiles={profiles}
                isNoTitle={Boolean(true)}
              />
            </div>
            <LoadSpinner isFetching={isFetching}/>
          </article>
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state, {}) => {
  const { device, entities } = state;
  return { device, entities };
};

export default connect(
  mapStateToProps,
  (dispatch) => bindActionCreators({
    showModal: actions.showModal
  }, dispatch)
)(tiaraClickSender(ProfileRecommendPage));


// WEBPACK FOOTER //
// ./src/containers/ProfileRecommendPage/index.js